import { useState } from "react";

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Poppins:wght@300;400;500;600&display=swap');

  * { box-sizing: border-box; margin: 0; padding: 0; }

  .pp-root {
    font-family: 'Poppins', sans-serif;
    background: #FDF6EE;
    color: #3a1a14;
    min-height: 100vh;
    overflow-x: hidden;
  }

  /* HERO */
  .pp-hero {
    background: #1a0a08;
    position: relative;
    overflow: hidden;
    padding: 64px 24px 80px;
    text-align: center;
  }
  .pp-hero::before {
    content: '';
    position: absolute;
    inset: 0;
    background: radial-gradient(ellipse 80% 60% at 50% 0%, rgba(239,49,34,0.35) 0%, transparent 70%);
    pointer-events: none;
  }
  .pp-hero-blob {
    position: absolute;
    width: 420px; height: 420px;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(239,49,34,0.15), transparent 70%);
    bottom: -140px; right: -100px;
    pointer-events: none;
  }
  .pp-logo {
    display: inline-flex;
    align-items: center; justify-content: center;
    width: 88px; height: 88px;
    border-radius: 22px;
    background: white;
    box-shadow: 0 8px 40px rgba(239,49,34,0.45);
    margin-bottom: 28px;
    animation: ppPopIn 0.7s cubic-bezier(.22,1.4,.64,1) both;
  }
  .pp-logo svg { width: 52px; height: 52px; fill: #fff; }
  .pp-hero h1 {
    font-family: 'Bebas Neue', sans-serif;
    font-size: clamp(3rem, 10vw, 5.5rem);
    font-weight: 400;
    color: #fff;
    line-height: 1;
    letter-spacing: 0.04em;
    animation: ppFadeUp 0.7s 0.15s both;
  }
  .pp-hero h1 span { color: #ff6b5b; }
  .pp-hero p {
    margin-top: 16px;
    font-size: 1rem;
    color: rgba(255,255,255,0.55);
    font-weight: 300;
    max-width: 400px;
    margin-inline: auto;
    line-height: 1.6;
    animation: ppFadeUp 0.7s 0.25s both;
  }
  .pp-badge {
    display: inline-block;
    margin-top: 24px;
    background: rgba(239,49,34,0.18);
    border: 1px solid rgba(239,49,34,0.4);
    color: #ff6b5b;
    font-size: 0.75rem;
    font-weight: 500;
    letter-spacing: 0.14em;
    text-transform: uppercase;
    padding: 6px 18px;
    border-radius: 100px;
    animation: ppFadeUp 0.7s 0.35s both;
  }

  @keyframes ppPopIn {
    from { transform: scale(0.6); opacity: 0; }
    to   { transform: scale(1);   opacity: 1; }
  }
  @keyframes ppFadeUp {
    from { transform: translateY(20px); opacity: 0; }
    to   { transform: translateY(0);    opacity: 1; }
  }

  /* UPDATED DATE */
  .pp-updated {
    text-align: center;
    padding: 20px 24px 0;
    font-size: 0.78rem;
    color: #9a6b62;
    font-weight: 400;
    letter-spacing: 0.05em;
  }

  /* MAIN */
  .pp-main {
    max-width: 720px;
    margin: 0 auto;
    padding: 48px 24px 80px;
  }

  /* INTRO */
  .pp-intro {
    background: #fff;
    border: 1.5px solid rgba(239,49,34,0.12);
    border-radius: 18px;
    padding: 28px 28px;
    margin-bottom: 40px;
    font-size: 0.93rem;
    line-height: 1.75;
    color: #5c2e26;
  }
  .pp-intro strong { color: #EF3122; }

  /* SECTION */
  .pp-section {
    margin-bottom: 14px;
    background: #fff;
    border: 1.5px solid rgba(239,49,34,0.1);
    border-radius: 16px;
    overflow: hidden;
    transition: box-shadow 0.2s, border-color 0.2s;
  }
  .pp-section.open {
    box-shadow: 0 8px 28px rgba(239,49,34,0.09);
    border-color: rgba(239,49,34,0.28);
  }

  .pp-section-header {
    display: flex;
    align-items: center;
    gap: 14px;
    padding: 20px 22px;
    cursor: pointer;
    user-select: none;
    transition: background 0.15s;
  }
  .pp-section-header:hover { background: rgba(239,49,34,0.03); }

  .pp-section-icon {
    width: 40px; height: 40px;
    border-radius: 11px;
    background: rgba(239,49,34,0.1);
    display: flex; align-items: center; justify-content: center;
    font-size: 18px;
    flex-shrink: 0;
  }
  .pp-section-title {
    font-family: 'Bebas Neue', sans-serif;
    font-size: 1.25rem;
    letter-spacing: 0.06em;
    color: #1a0a08;
    flex: 1;
  }
  .pp-chevron {
    color: #EF3122;
    font-size: 1rem;
    transition: transform 0.25s;
    flex-shrink: 0;
  }
  .pp-section.open .pp-chevron { transform: rotate(180deg); }

  .pp-section-body {
    display: none;
    padding: 0 22px 22px;
    border-top: 1px solid rgba(239,49,34,0.07);
    padding-top: 18px;
  }
  .pp-section.open .pp-section-body { display: block; }

  .pp-section-body p {
    font-size: 0.9rem;
    color: #9a6b62;
    line-height: 1.75;
    margin-bottom: 12px;
  }
  .pp-section-body p:last-child { margin-bottom: 0; }

  .pp-list {
    list-style: none;
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin: 12px 0;
  }
  .pp-list li {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    font-size: 0.88rem;
    color: #5c2e26;
    line-height: 1.6;
  }
  .pp-list li::before {
    content: '▸';
    color: #EF3122;
    font-size: 0.75rem;
    margin-top: 3px;
    flex-shrink: 0;
  }

  .pp-tag {
    display: inline-block;
    background: rgba(239,49,34,0.08);
    color: #EF3122;
    font-size: 0.75rem;
    font-weight: 600;
    padding: 3px 10px;
    border-radius: 100px;
    margin: 2px;
  }
  .pp-tag.green {
    background: rgba(34,197,94,0.1);
    color: #16a34a;
  }

  /* CONTACT STRIP */
  .pp-contact {
    margin-top: 40px;
    background: #1a0a08;
    border-radius: 18px;
    padding: 32px 28px;
    text-align: center;
  }
  .pp-contact h3 {
    font-family: 'Bebas Neue', sans-serif;
    font-size: 1.8rem;
    letter-spacing: 0.06em;
    color: #fff;
    margin-bottom: 8px;
  }
  .pp-contact p {
    font-size: 0.88rem;
    color: rgba(255,255,255,0.5);
    margin-bottom: 20px;
    line-height: 1.6;
  }
  .pp-contact-links {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    justify-content: center;
  }
  .pp-contact-btn {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 10px 20px;
    border-radius: 100px;
    font-size: 0.85rem;
    font-weight: 500;
    font-family: 'Poppins', sans-serif;
    text-decoration: none;
    transition: transform 0.2s, box-shadow 0.2s;
    cursor: pointer;
  }
  .pp-contact-btn:hover { transform: translateY(-2px); box-shadow: 0 6px 20px rgba(0,0,0,0.25); }
  .pp-contact-btn.primary { background: #EF3122; color: #fff; }
  .pp-contact-btn.secondary { background: rgba(255,255,255,0.1); color: #fff; border: 1px solid rgba(255,255,255,0.15); }

  /* FOOTER */
  .pp-footer {
    background: #1a0a08;
    text-align: center;
    padding: 28px 24px;
    color: rgba(255,255,255,0.3);
    font-size: 0.8rem;
    margin-top: 2px;
  }
  .pp-footer span { color: #ff6b5b; }

  /* SECTION LABEL */
  .pp-label {
    font-size: 0.7rem;
    font-weight: 600;
    letter-spacing: 0.18em;
    text-transform: uppercase;
    color: #EF3122;
    margin-bottom: 16px;
    margin-top: 36px;
    display: block;
  }
  .pp-label:first-child { margin-top: 0; }
`;

const sections = [
  {
    icon: "📋",
    title: "Information We Collect",
    content: (
      <>
        <p>When you use Varag Vardan, we collect the following information to provide our grocery delivery service:</p>
        <ul className="pp-list">
          <li><strong>Contact Information:</strong> Your name, email address, and phone number used to create and manage your account.</li>
          <li><strong>Physical Address:</strong> Your delivery address(es) to fulfill your grocery orders.</li>
          <li><strong>Precise Location (GPS):</strong> Your real-time location during delivery to ensure accurate and efficient drop-off.</li>
          <li><strong>User ID:</strong> A unique identifier generated via Firebase Authentication to manage your account securely.</li>
          <li><strong>Order History:</strong> Items, quantities, prices, and past orders to process and manage your purchases.</li>
          <li><strong>User Content:</strong> Order notes, custom instructions, or any content you submit during the ordering process.</li>
          <li><strong>Usage Data:</strong> How you interact with the app — cart actions, product browsing, and order flow — to improve your experience.</li>
        </ul>
      </>
    ),
  },
  {
    icon: "🚫",
    title: "Data We Do NOT Collect",
    content: (
      <>
        <p>We are committed to collecting only what is necessary. We do <strong>not</strong> collect:</p>
        <div style={{ display: "flex", flexWrap: "wrap", gap: "6px", margin: "12px 0" }}>
          {["Payment card details", "Phone contacts/phonebook", "Health information", "Audio recordings", "Device advertising ID", "Crash reports", "Analytics data", "Biometric data"].map(t => (
            <span key={t} className="pp-tag green">✓ Not collected: {t}</span>
          ))}
        </div>
        <p>Since we do not process in-app card payments, no financial information is ever stored or handled by us.</p>
      </>
    ),
  },
  {
    icon: "🎯",
    title: "How We Use Your Data",
    content: (
      <>
        <p>Your data is used solely to operate and improve Varag Vardan:</p>
        <ul className="pp-list">
          <li>Processing and delivering your grocery orders to your address.</li>
          <li>Sending order confirmations, delivery updates, and support communications.</li>
          <li>Managing your account and order history.</li>
          <li>Improving our app experience based on how you use it.</li>
          <li>Resolving disputes, handling complaints, and providing customer support.</li>
        </ul>
        <p>We do not use your data for advertising, profiling, or selling to third parties.</p>
      </>
    ),
  },
  {
    icon: "🤝",
    title: "Data Sharing & Third Parties",
    content: (
      <>
        <p>We only share your data with the following parties, strictly to fulfil your orders:</p>
        <ul className="pp-list">
          <li><strong>Delivery Riders (Rider App):</strong> Your name, phone number, delivery address, and order details are shared with the rider assigned to your order through our internal rider app. This is necessary to complete your delivery.</li>
          <li><strong>Firebase (Google):</strong> We use Firebase to securely store your account data, order history, and app content. Firebase is a Google service governed by Google's Privacy Policy. Your data is stored securely on Firebase servers.</li>
        </ul>
        <p>We do not sell, rent, or share your personal data with any marketing companies, advertisers, or unrelated third parties.</p>
      </>
    ),
  },
  {
    icon: "📍",
    title: "Location Data",
    content: (
      <>
        <p>We request access to your precise GPS location for the following purposes:</p>
        <ul className="pp-list">
          <li>To accurately identify your delivery address when placing an order.</li>
          <li>To provide real-time delivery tracking so you can follow your order.</li>
          <li>To assist riders in locating your address efficiently.</li>
        </ul>
        <p>Location is only accessed when the app is in use and you have granted permission. You can revoke location access at any time through your iPhone's Settings → Privacy → Location Services → Varag Vardan.</p>
      </>
    ),
  },
  {
    icon: "🔒",
    title: "Data Security",
    content: (
      <>
        <p>We take reasonable measures to protect your personal information:</p>
        <ul className="pp-list">
          <li>All data is stored on Firebase, which uses industry-standard encryption.</li>
          <li>Account access is secured through Firebase Authentication.</li>
          <li>Only authorized staff and riders with a specific need can access your order information.</li>
        </ul>
        <p>While we strive to protect your data, no method of transmission over the internet is 100% secure. We encourage you to keep your account credentials confidential.</p>
      </>
    ),
  },
  {
    icon: "👤",
    title: "Your Rights",
    content: (
      <>
        <p>You have the following rights regarding your personal data:</p>
        <ul className="pp-list">
          <li><strong>Access:</strong> Request a copy of the data we hold about you.</li>
          <li><strong>Correction:</strong> Ask us to correct any inaccurate information.</li>
          <li><strong>Deletion:</strong> Deletion: You can permanently delete your account and all associated data directly from the app via Profile → Delete Account. Deletion is immediate and cannot be undone.</li>
          <li><strong>Withdraw Consent:</strong> Revoke location or notification permissions at any time via your iPhone settings.</li>
        </ul>
        <p>To exercise any of these rights, contact us via WhatsApp or email and we will respond within 7 business days.</p>
      </>
    ),
  },
  {
    icon: "🧒",
    title: "Children's Privacy",
    content: (
      <>
        <p>Varag Vardan is not directed at children under the age of 13. We do not knowingly collect personal information from children.</p>
        <p>If you believe a child has provided us with personal information, please contact us immediately and we will delete it promptly.</p>
      </>
    ),
  },
  {
    icon: "📝",
    title: "Changes to This Policy",
    content: (
      <>
        <p>We may update this Privacy Policy from time to time. When we do, we will update the "Last Updated" date at the top of this page.</p>
        <p>Continued use of Varag Vardan after any changes means you accept the updated policy. We encourage you to review this page periodically.</p>
      </>
    ),
  },
];

export default function PrivacyPolicy() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (i:any) => setOpenIndex(openIndex === i ? null : i);

  return (
    <>
      <style>{styles}</style>
      <div className="pp-root">

        {/* HERO */}
        <div className="pp-hero">
          <div className="pp-hero-blob" />
          <div className="pp-logo"> 
          <img src="logo.png" alt="Varag Vardan" style={{width: '100%', height: '100%', objectFit: 'contain'}} />
       
          </div>
          <h1>Varag <span>Vardan</span></h1>
          <p>We respect your privacy. Here's exactly what we collect, why, and how we protect it.</p>
          <div className="pp-badge">Privacy Policy</div>
        </div>

        <p className="pp-updated">Last Updated: January 1, 2026</p>

        {/* MAIN */}
        <main className="pp-main">

          {/* INTRO */}
          <div className="pp-intro">
            This Privacy Policy explains how <strong>Varag Vardan</strong> — Gwadar's first grocery delivery app — collects, uses, and protects your personal information when you use our app. By using Varag Vardan, you agree to the practices described in this policy.
          </div>

          <span className="pp-label">Policy Details</span>

          {/* ACCORDION SECTIONS */}
          {sections.map((s, i) => (
            <div
              key={i}
              className={`pp-section${openIndex === i ? " open" : ""}`}
            >
              <div className="pp-section-header" onClick={() => toggle(i)}>
                <div className="pp-section-icon">{s.icon}</div>
                <div className="pp-section-title">{s.title}</div>
                <div className="pp-chevron">▼</div>
              </div>
              <div className="pp-section-body">
                {s.content}
              </div>
            </div>
          ))}

          {/* CONTACT */}
          <div className="pp-contact">
            <h3>Questions About Your Privacy?</h3>
            <p>Reach out to us directly — we're happy to help with any privacy concerns.</p>
            <div className="pp-contact-links">
              <a className="pp-contact-btn primary" href="https://wa.me/923218628554" target="_blank" rel="noopener noreferrer">
                📱 WhatsApp Us
              </a>
              <a className="pp-contact-btn secondary" href="mailto:varagovardan@gmail.com">
                ✉️ Email Us
              </a>
            </div>
          </div>

        </main> 
      </div>
    </>
  );
}